import { NativeBiometric } from '@capgo/capacitor-native-biometric';

import ENVIRONMENT from '@/environments/environment';
import { ClientTaxonomyEvents } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';

import { Analytics } from './analytics';
import { storageService } from './storage';

const typeOfBiometryAvailable = async () => {
  try {
    const result = await NativeBiometric.isAvailable();

    if (result.isAvailable) {
      return result.biometryType;
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
};

const performBiometricVerification = async () => {
  try {
    const result = await NativeBiometric.isAvailable();
    if (!result.isAvailable) return undefined;

    const verified = await NativeBiometric.verifyIdentity({
      reason: 'Inicio de sesión más rápido',
      title: 'Inicio de sesión',
    })
      .then(() => result.biometryType)
      .catch(() => undefined);

    return verified;
  } catch (error) {
    return undefined;
  }
};

const getBiometricCredentials = async () => {
  const verifyType = await performBiometricVerification();

  if (verifyType !== undefined) {
    const credentials = await NativeBiometric.getCredentials({
      server: ENVIRONMENT.BIOMETRIC_SERVER!,
    });
    return credentials;
  }
  return undefined;
};

const setBiometricCredentials = async (
  username: string,
  password: string,
) => {
  const verifyType = await performBiometricVerification();
  if (verifyType !== undefined) {
    // Solo limpia lo anterior: si no había credenciales puede fallar y no debe impedir el guardado
    await NativeBiometric.deleteCredentials({ server: ENVIRONMENT.BIOMETRIC_SERVER! })
      .catch(() => {});
    return NativeBiometric.setCredentials({
      username,
      password,
      server: ENVIRONMENT.BIOMETRIC_SERVER!,
    }).then(() => {
      storageService.setBiometrySaved(verifyType);
      Analytics.registerAnalyticsEvent({ [ClientTaxonomyEvents.BIOMETRIC_ENABLEMENT]: {} });
      return true;
    })
      .catch(() => false);
  }

  return false;
};

const clearBiometricCredentials = () => NativeBiometric.deleteCredentials({
  server: ENVIRONMENT.BIOMETRIC_SERVER!,
}).then(storageService.clearBiometrySaved);

export {
  clearBiometricCredentials,
  getBiometricCredentials,
  setBiometricCredentials,
  typeOfBiometryAvailable,
};
